import z from 'zod';

import { EMedicalSpecialtyStatus } from '@enums/medicalSpecialties.enum';
import { onlyNumberFormatter } from '@formatters/onlyNumber.formatter';

export const medicalSpecialtySchema = z.object({
  status: z.enum(EMedicalSpecialtyStatus, {
    error: 'Status da especialidade médica é obrigatório',
  }),
  id: z.string({
    error: 'ID da especialidade médica é obrigatório',
  }),
  name: z.string().default('').optional(),
});

export const createCollaboratorSchema = z.object({
  documents: z
    .instanceof(File)
    .refine(file => file.size > 0, 'Arquivo vazio')
    .refine(file => file.size <= 5 * 1024 * 1024, 'Máx. 5MB')
    .refine(
      file =>
        ['image/jpeg', 'image/png', 'application/pdf'].includes(file.type),
      'Formato inválido',
    )
    .array()
    .nonempty({
      message: 'É obrigatório o envio de pelo menos 1 documento',
    }),
  email: z
    .email({
      error: 'E-mail é obrigatória e deve ser válido (ex: exemplo@exemplo.com)',
    })
    .toLowerCase()
    .trim(),
  password: z
    .string({
      error: 'Senha é obrigatória',
    })
    .min(1, {
      message: 'Senha é obrigatória',
    }),
  phone: z
    .string({
      error: 'Telefone é obrigatório',
    })
    .length(15, {
      message: 'Telefone deve conter 11 dígitos',
    })
    .transform(value => onlyNumberFormatter(value)),
  crm: z
    .string({
      error: 'CRM é obrigatório',
    })
    .min(1, {
      message: 'CRM é obrigatório',
    }),
  document: z
    .string({
      error: 'CPF é obrigatório',
    })
    .min(1, {
      message: 'CPF é obrigatório',
    })
    .transform(value => onlyNumberFormatter(value)),
  name: z
    .string({
      error: 'Nome é obrigatório',
    })
    .min(3, {
      message: 'Nome deve conter no mínimo 3 caracteres',
    }),
  medicalSpecialties: z.array(medicalSpecialtySchema).nonempty({
    message: 'É obrigatório o envio de pelo menos 1 especialização médica',
  }),
});

export type CreateCollaboratorMedicalSpecialtySchema = z.infer<
  typeof medicalSpecialtySchema
>;

export type CreateCollaboratorPayload = z.infer<
  typeof createCollaboratorSchema
>;
